import axios from 'axios'
import store from '@/store'
import { getToken } from '@/utils/auth'
import { setToken, removeToken } from '@/utils/auth'
import Cookies from 'js-cookie'
import * as tools from './tools'
import Vue from 'vue'
import storage from '@/utils/storage'
var mesg = ''
const http = axios.create({
  baseURL: '',
  timeout: 30000
})

// request 拦截器
http.interceptors.request.use(
  config => {
    if (store.getters.token) {
      config.headers['eden-token'] = getToken()
    }
    return config
  },
  error => {
    return Promise.reject(error)
  }
)

// respone 拦截器
http.interceptors.response.use(
  response => {
    const res = response.data
    // if (res.code == -10) {
    //   Vue.prototype.$notify({
    //     title: '提示信息',
    //     message: res.message,
    //     type: 'warning',
    //     position: 'top-right',
    //     duration: 5000
    //   })
    //   Cookies.remove('user', { path: '' })
    //   removeToken()
    //   window.location.reload()
    // }else if(res.code == 200 && res.data && res.data.length==0){
    //   Vue.prototype.$notify({
    //     title: '提示信息',
    //     message: '暂无数据',
    //     type: 'warning',
    //     position: 'top-right',
    //     duration: 5000
    //   })

    // } else if (res.code == 505) {
    //   Vue.prototype.$notify({
    //     title: '提示信息',
    //     message: res.message,
    //     type: 'warning',
    //     position: 'top-right',
    //     duration: 5000
    //   })
    //   setTimeout(() => {
    //     axios.post('/bi-api/logout').then(e => {
    //       if (e.code == 200) {
    //         vm.$router.push({
    //           path: '/login'
    //         })
    //       }
    //     })
    //   }, 2000);
    // }else if(res.code != 200){
    //   Vue.prototype.$notify({
    //     title: '提示信息',
    //     message: res.message,
    //     type: 'warning',
    //     position: 'top-right',
    //     duration: 5000
    //   })

    // }
    if (res.code == 200) {
      // 如果是 /bi-api/auth 请求且返回成功，存储 permissions
      if (response.config && response.config.url && response.config.url.indexOf('/bi-api/auth') !== -1) {
        if (res.data && res.data.permissions && Array.isArray(res.data.permissions)) {
          storage.set('permissions', res.data.permissions)
        }
      }
      if (res.data && res.data.list && res.data.list.length == 0) {
        Vue.prototype.$notify({
          title: '提示信息',
          message: '暂无数据',
          type: 'warning',
          position: 'top-right',
          duration: 5000
        })
      }
    } else if (res.code != 200) {
      res.message=res.message||"";//防止message返回null
      if (mesg != res.message) {
        Vue.prototype.$notify({
          title: '提示信息',
          message: res.message,
          type: 'warning',
          position: 'top-right',
          duration: 3000
        })
      }
      mesg = res.message;
      setTimeout(() => { mesg = '' }, 3300)
      if (res.code == 505) {
        setTimeout(() => {
          http.post('/bi-api/logout').then(e => {
            // if (e.code == 200) {
            storage.remove('areaList')
            storage.remove('permissions')
            tools.clearCookie();
            if ((vm.$route.path).indexOf("roadOperation") !== -1) {
              vm.$router.push({
                path: '/roadLogin'
              })
            } else {
              vm.$router.push({
                path: '/login'
              })
            }

            // }
          })
        }, 500);
        return;
      }
      if (res.code == -10) {
        storage.remove('permissions')
        tools.clearCookie();
        removeToken()
        // window.location.reload()
        if ((vm.$route.path).indexOf("roadOperation") !== -1||(vm.$route.path).indexOf("roadLogin") !== -1) {
          vm.$router.push({
            path: '/roadLogin'
          })
        } else {
          vm.$router.push({
            path: '/login'
          })
        }
      }
    }
    if (res.error) {
      tools.notify({
        type: 'error',
        message: res.error.message
      })
      if (res.code === '-10') {
        // 接口自定义错误代码
        // 移除登陆token 显示接口错误消息
      }
      return Promise.reject(res)
    }
    return Promise.resolve(res)
  },
  error => {
    Vue.prototype.$notify({
      type: 'error',
      message: error.message,
      duration: 5000
    })
    return Promise.reject(error)
  }
)

export default http
